/* eslint-disable eqeqeq */
import * as cloneDeep from 'lodash/cloneDeep'

export default {
  SAVE_INITIAL_DATA (state, {data, token, type, config, init}) {
    state.data = data
    state.initialData = cloneDeep(data)
    state.token = token
    state.type = type

    state.data = {...state.data, style: {...state.data.style, ...config.colors}}
    if (init) {
      state.isVisible = config.showOnStart
      state.autoChangeFlight = config.autoChangeFlight
      state.mobileLegendOnTop = config.mobileLegendOnTop
    }

    if (!state.flight) {
      state.flightId = data.flights[0].id
      state.passengerId = data.flights[0].passengers[0].id
    }

    // console.log('saved load data')
  },

  CHANGE_FLIGHT (state, {selectedFlightId, getters}) {
    state.flightId = selectedFlightId
    state.passengerId = getters.flight.passengers[0].id
  },

  SET_ENV (state, {env}) {
    state.injectedEnv = env
  },

  CHANGE_PASSENGER (state, selectedPassengerId) {
    state.passengerId = selectedPassengerId
  },

  SELECT_SEATS_AUTOMATICALLY (state, {getters}) {
    let possibleSeatsToAssign = getters.availableSeatObjectsOnThisFlight.slice(0, getters.flight.passengers.length)

    getters.flight.passengers.forEach((passenger, index) => {
      passenger.seat = possibleSeatsToAssign[index]

      window.EventBus.dispatchEvent('ss-seat-selected', { passenger, selectedSeat: possibleSeatsToAssign[index] })
    })
  },

  TOGGLE_SELECTOR (state) {
    state.isVisible = !state.isVisible
  },

  COMPLETED (state, data) {
    state.confirming = false
    // state.initialData = cloneDeep(data)
  },

  SELECT_SEAT (state, {selectedSeat, getters}) {
    state.data.flights.forEach((flight, flightIndex) => {
      if (flight.id === state.flightId) {
        flight.passengers.forEach((passenger, passengerIndex) => {
          if (passenger.id === state.passengerId) {
            passenger.seat = selectedSeat
            window.EventBus.dispatchEvent('ss-seat-selected', {passenger, selectedSeat})
          }
        })
      }
    })
  },

  DESELECT_SEAT (state, {getters}) {
    state.data.flights.forEach((flight, flightIndex) => {
      if (flight.id === state.flightId) {
        flight.passengers.forEach((passenger, passengerIndex) => {
          if (passenger.id === state.passengerId) {
            passenger.seat = {designator: null}
            window.EventBus.dispatchEvent('ss-seat-deselected', {passenger})
          }
        })
      }
    })
  },

  UPDATED_PASSENGER (state, updatedPassenger) {
    state.data.flights.forEach((flight, flightIndex) => {
      flight.passengers.forEach((passenger, passengerIndex) => {
        if (passenger.id == updatedPassenger.id) {
          const name = updatedPassenger.name || ''
          const lastName = updatedPassenger.last_name || ''
          passenger.name = name + ' ' + lastName
        }
      })
    })
  },

  UPDATED_PASSENGER_SEAT (state, updatedData) {
    state.data.flights.forEach((flight, flightIndex) => {
      flight.passengers.forEach((passenger, passengerIndex) => {
        if (passenger.id == updatedData.passenger.id) {
          const name = updatedData.passenger.name || ''
          const lastName = updatedData.passenger.last_name || ''
          passenger.name = name + ' ' + lastName
          passenger.seat = {
            designator: updatedData.seat,
            price: updatedData.price
          }
        }
      })
    })
  },

  HIDE_MODAL (state) {
    state.isModalVisible = false
  },

  SET_CONFIRMING (state) {
    state.confirming = true
  },

  SHOW_MODAL (state, {text, type}) {
    state.isModalVisible = true
    state.modalText = text
    state.modalType = type
  },

  SET_LOADING (state, loading) {
    state.loading = loading
  }
}



// WEBPACK FOOTER //
// ./src/data/mutations.js